/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { useEffect, useRef } from "react";
import { Location, useLocation } from "react-router-dom";

const useOnPathChange = (callback: (location: Location) => void) => {
  const location = useLocation();
  const pathRef = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== pathRef.current) {
      pathRef.current = location.pathname;
      callback(location);
    }
  }, [location, callback]);
};

export default useOnPathChange;
